import EmailTemplatesTable from './EmailTemplatesTable';

export default EmailTemplatesTable;
